module.exports = __webpack_public_path__ + "static/media/money.544191b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/money.svg
// module id = 1133
// module chunks = 0